export const SUCCESS_MESSAGE = {
  title: "Arquivo adicionado com sucesso",
  message: "O arquivo foi importado sem erros."
};

export const ERROR_MESSAGE = {
  title: "Erro de importação",
  message: "Ocorreu um erro ao tentar importar sua avaliação."
}

// Link do modelo de arquivo csv
export const FILE_MODEL_LINK = process.env.REACT_APP_S3_BASE_URL + "tensai/poc/Modelo%2Bde%2BCSV%2Bpara%2Bimportação%2Bno%2BAnalyze.csv";

// Link do modelo do arquivo pdf com as orientações sobre o csv
export const FILE_DOC_LINK = process.env.REACT_APP_S3_BASE_URL + "tensai/poc/Estrutura+do+arquivo+CSV+—+Bases+de+respostas+para+o+Analyze.pdf";

// Texto da tooltip
export const FILE_MODEL_TOOLTIP_TEXT = "O arquivo deve seguir a formatação do modelo disponibilizado abaixo";

/**
 * Tempo de debounce para auto-load de URL de cloud storage.
 */
export const CLOUD_INPUT_DEBOUNCE_MS = 800;

/**
 * Timeout para requisicoes fetch a servicos cloud (30s).
 */
export const CLOUD_FETCH_TIMEOUT_MS = 30000;

/**
 * Comprimento minimo de URL antes de validar.
 */
export const CLOUD_URL_MIN_LENGTH = 20;